import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/style.scss";
import { useLocation } from "react-router-dom";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Sections from "./Components/Sections";
import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import site from "./data.json";

function App() {
  const location = useLocation();
  const pageIdentifier = location.pathname.substring(1);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
  }, [pageIdentifier]);

  const { content = {} } = site;
  const { pages = [], header = {}, footer = {}, globals = {} } = content;
  const page = pages.find((p) => p.identifier === pageIdentifier) || pages[0] || {};
  const { sections = [] } = page;

  const absBanners = ["SECTION_BANNERALT", "SECTION_BANNERALT4", "SECTION_BANNERMAIN"];
  const bannerType = sections.length > 0 ? sections[0].type : "Unknown";
  const navbarPosition = absBanners.includes(bannerType) ? "position-absolute" : "";
  const navbarStartLight = ["SECTION_BANNERALT", "SECTION_BANNERALT4", "SECTION_BANNERMAIN"].includes(bannerType);
  const navbarTextColour = navbarStartLight ? "dark" : "light";
  const headervm = { ...header, globals, navbarStartLight, navbarPosition, navbarTextColour };

  const pageContent = page.content || {};
  const { extendedProperties = [] } = pageContent;
  const description = extendedProperties?.find((p) => p.name === "description")?.value || globals.siteDescription;
  const keywords = extendedProperties?.find((p) => p.name === "keywords")?.value || globals.siteKeywords;
  const title = extendedProperties?.find((p) => p.name === "title")?.value || globals.title;
  const robots = extendedProperties?.find((p) => p.name === "robots")?.value || "index, follow";
  const author = extendedProperties?.find((p) => p.name === "author")?.value || globals.author;

  return (
    <>
      <Helmet>
        {title && <title>{title}</title>}
        {description && <meta name="description" content={description} />}
        {author && <meta name="author" content={author} />}
        {keywords && <meta name="keywords" content={keywords} />}
        {robots && <meta name="robots" content={robots} />}
        {extendedProperties
          ?.filter((p) => p.name.startsWith("og:"))
          ?.map((p, i) => (
            <meta property={p.name} content={p.value} key={i} />
          ))}
        {extendedProperties
          ?.filter((p) => p.name.startsWith("twitter:"))
          ?.map((p, i) => (
            <meta name={p.name} content={p.value} key={i} />
          ))}
      </Helmet>
      <Header header={headervm} globals={globals} pageIdentifier={pageIdentifier} />

      <Routes>
        <Route path="*" element={<Sections sections={sections} />} />
      </Routes>

      <Footer globals={globals} footer={footer} />
      <button
        className="scroll-top"
        onClick={() =>
          window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
          })
        }
      >
        <i className="bi bi-arrow-up-short"></i>
      </button>
    </>
  );
}

export default App;
